import "imports-loader?this=>window!../../Scripts/modernizr-custom"; 

import * as angular from "angular";
import * as _ from "lodash"; 

import { directivesModule } from "../directivesModule";

import { BaseModel, AtonixRedirector } from "../Models/model";
import "../Models/model";

import { AssetsModel } from "../Models/AssetsModel";
import "../Models/AssetsModel";

import { UIConfigModel } from "../Models/UIConfigModel";
import "../Models/UIConfigModel";

import { AccountModel } from "../Models/AccountModel";
import "../Models/AccountModel";

import { AuthorizationModel } from "../Models/AuthorizationModel";
import "../Models/AuthorizationModel";

import "../NavBar/NavBar";

import "./ATXRedrawService";
import { ATXRedrawService } from "./ATXRedrawService";

import "../Notifications/Notifications";
import { Notifications } from "../Notifications/Notifications";

export interface ITab {
	DisplayOrder: number;
	DisplayText: string;
	Path?: string;
	Hide?: boolean; 
}

export class PaneController implements angular.IController {
	public bvTitle: string;
	public appContext: string;
	public westsize: number;
	public southsize: number;
	public eastsize: number;
	public showsouth: boolean;
	public showwest: boolean;
	public showeast: boolean;
	public tabs: ITab[];
	public selectedTab: ITab;
	public contextchanged: (params: any) => { cancel: boolean };
	public tabchanged: (params: any) => void;
	public preventPhones: boolean;


	public applicationContexts: model.IAppContext[];
	public selectedAppContext: model.IAppContext;
	public appTrayPinned: boolean;
	public asset360Logo: string;
	public startupAppTray: boolean;

	//Indicate the collapsed state of the pane, not the visible state.
	public assetTree: boolean = true;
	public timeSlider: boolean = true;
	public assetTray: boolean = true;

	public isSmall: boolean;


	private mqlListener: (mediaQueryList: MediaQueryList)=>any;
	private mql: MediaQueryList;

	//This is used to cancel the interval which checks for an inactivity timeout. 
	//Intervals don't cancel on their own so it needs to be cancelled in the destroy.
	private checkForIntervalPromise: angular.IPromise<void>; 

	//Set the inactivity to 5 minutes.  It probably should be set in the server instead of on the client.  
	private timeoutLength = 1000 * 60 * 5;

	//The location to save the last interaction time.  
	private checkForTimeoutKey: string = 'ATX_LAYOUT_CHECKFORTIMEOUT';

	//The value in the scope is coming from the outside and should indicate whether showing south or west is an option
	//The value in the controller is calculated based on the size and the scope variable and actually determines if the pane is shown
	//When the display is small, only show west or show south can be active at once.  
	public containerToShow: string = "";

	constructor(private $timeout: angular.ITimeoutService, private $interval: angular.IIntervalService, private $log: angular.ILogService, private aTXRedrawService: ATXRedrawService, private $window: angular.IWindowService, private assetsModel: AssetsModel, private baseModel: BaseModel, private uiconfigModel: UIConfigModel, private authModel: AuthorizationModel, private notifications: Notifications, private accountModel: AccountModel, private atonixRedirector: AtonixRedirector) {
		this.asset360Logo = null;
		uiconfigModel.getAsset360Logo().then((bvLogo) => {
			this.asset360Logo = bvLogo;
		})
			.catch((error) => {
				$log.error("Could not get logo");
			});

		this.appTrayPinned = (baseModel.storage[baseModel.appTrayPinnedStorageKey] == 1);
		if (this.appTrayPinned) {
			this.setAppTrayState();
		}
		else {
			//This implements the function where the app tray starts out visible then hides after 3 seconds. 
			this.startupAppTray = true;
			this.$timeout(() => {
				this.startupAppTray = false;
			}, 3000);
		}

		assetsModel.getAppContextsAndProcess()
			.then((myACs) => {
				this.applicationContexts = myACs;
				this.processAppContext(this.appContext);
			});

		//This is a debounced function to be called when the user interacts with the UI.
		//It will only be called once every 2 seconds no matter how often the user interacts with the site.
		let debouncedListener = _.debounce(() => {
			this.onUserInteraction();
		}, 2000, { leading: true, trailing:true });


		//The event listeners cant be cancelled.  Performance will be improved if the listener can make that
		//assumption.  Unfortunately, not every browser can take advantage of this feature.  So we detect
		//the feature and pass the object only if the feature is available.  
		let options: boolean | AddEventListenerOptions = false; 
		if (Modernizr.passiveeventlisteners) {
			options = { passive: true };
		}

		//Listen for mouse move and keydown events.  This list can be expanded as needed.  
		$window.addEventListener("mousemove", debouncedListener, <any>options);
		$window.addEventListener("keydown", debouncedListener, <any>options);

		//This will trigger any time a 'different' window changes storage.  It 
		//currently calls the storage changed event whenever storage changes at all.
		//The storage changed method then filters out everything but the key it is watching.  
		$window.addEventListener("storage", (event: any) => {
			this.storageChanged(event);
		}, <any>options);

		//Here we check to see if the interval has elapsed every 5 seconds. 

		this.authModel.timeoutSetting()
			.then((timeoutInMinutes) => {
				this.timeoutLength = 1000 * 60 * timeoutInMinutes;
				if (timeoutInMinutes > 0) {
					this.checkForIntervalPromise = $interval(() => {
						this.checkForTimeout();
					}, 5 * 1000, 0, true);
				}
			})
			.catch(() => {
				//If there is an error retrieving this it is probably due to a non-authorized user.  We want to let the 
				//interceptor do its job so we don't need to do anything here.  
			});
		

		//This will create an initial value in the last interaction time storage value.  
		this.onUserInteraction(); 

	}

	public $onInit() { }
	public $doCheck() { }
	public $onChanges(onChangesObj: angular.IOnChangesObject) {
		if (onChangesObj['appContext'] && !onChangesObj['appContext'].isFirstChange()) {
			this.processAppContext(onChangesObj['appContext'].currentValue);
		}
	}
	public $postLink() {
		//This will set up the media query watcher
		if (this.$window && this.$window.matchMedia) {

			//This is the media query for small and extra small devices 
			this.mql = this.$window.matchMedia("(max-width:767px)");
			this.mqlListener = (mediaQueryList:MediaQueryList) => {
				if (mediaQueryList.matches !== this.isSmall) {
					//This may need to be in a scope.$apply
					this.$timeout(() => {
						this.changeSize(mediaQueryList.matches);
					});
					
				}
				return null; 
			};
			this.mql.addListener(this.mqlListener as any);

			this.changeSize(this.mql.matches);

			//This is the media query just for extra small devices
			//var mql = window.matchMedia("(max-width:767px)"); 
		}
	}

	public $onDestroy() {
		if (this.mql && this.mqlListener) {
			this.mql.removeListener(this.mqlListener as any);
		}

		//This means there is an user interaction timer running.
		if (this.checkForIntervalPromise) {
			this.$interval.cancel(this.checkForIntervalPromise);
		}
	}

	public toggleSouth() {
		if (this.isSmall) {
			if (this.containerToShow === "south") {
				this.containerToShow = "";
			}
			else {
				this.containerToShow = "south";
			}
			this.aTXRedrawService.Layout("resize", "");
		}
		else {
			this.timeSlider = !this.timeSlider;
		}
	}

	public toggleWest() {
		if (this.isSmall) {
			if (this.containerToShow === "west") {
				this.containerToShow = "";
			}
			else {
				this.containerToShow = "west";
			}
		}
		else {
			this.assetTree = !this.assetTree;
		}
	}

	public toggleEast() {
		if (this.isSmall) {
			if (this.containerToShow === "east") {
				this.containerToShow = "";
			}
			else {
				this.containerToShow = "east";
			}
		}
		else {
			this.assetTray = !this.assetTray;
		}
	}

	private processAppContext(selectedAppContextName: string) {
		if (angular.isDefined(selectedAppContextName) && this.applicationContexts) {
			this.selectedAppContext = null;

			for (var j = 0; j < this.applicationContexts.length; j++) {
				if (this.applicationContexts[j].DisplayName.toLowerCase() == selectedAppContextName.toLowerCase()) {
					this.selectedAppContext = this.applicationContexts[j];
					break;
				}
			}

			if (this.selectedAppContext) {
				this.baseModel.setAppContext(this.selectedAppContext.AppContextID);
				this.appContext = this.selectedAppContext.DisplayName;
			}
		}
	}

	public pinIcon() {
		return this.appTrayPinned ? "/Content/pushpinin.png" : "/Content/pushpinout.png";
	}

	public toggleTrayPin() {
		this.appTrayPinned = !this.appTrayPinned;

		this.setAppTrayState();
	}

	public setAppTrayState() {
		this.$timeout(() => {
			this.aTXRedrawService.AppTrayPinChange(); 
		}, 650);

		this.baseModel.storage[this.baseModel.appTrayPinnedStorageKey] = this.appTrayPinned ? 1 : 0;  //save state for user
	}

	public changeTab(tab: ITab) {
		if (this.tabchanged) {
			this.tabchanged({ 'tab': tab });
		}
	}

	public changeAppContext(newAppContext: model.IAppContext) {

		if (this.contextchanged) {
			var scopeChangeResult = this.contextchanged({ 'newAppContext': newAppContext });
			if (scopeChangeResult && scopeChangeResult.cancel) {
				this.appContext = newAppContext.DisplayName;
				//Make sure that local variables are kept up to date with changes
				this.processAppContext(newAppContext.DisplayName);
				return;
			}
		}

		//If the app context is set to open in a new window then do that.  
		//If there is only one app context available then don't waste a new window, just open it locally.
		if (newAppContext.OpenInNew) {
			//Let the layout controller handle this situation.  
			if (this.applicationContexts.length > 1) {
				this.baseModel.openNew(newAppContext.Path);
			}
			else {
				this.baseModel.openInCurrent(newAppContext.Path);
			}
			return;
		}

		else if (newAppContext.Path.indexOf("Asset360") === -1) {
			this.baseModel.openInCurrent(newAppContext.Path);
			return;
		}
		this.baseModel.openInCurrent("/Asset360/#!?ac=" + encodeURIComponent(newAppContext.DisplayName));
		return;

		
	}

	public southExpanded() {
		return (this.showsouth === undefined || this.showsouth) && ((this.isSmall && this.containerToShow === "south") || (!this.isSmall && this.timeSlider));
	}

	public westExpanded() {
		return (this.showwest === undefined || this.showwest) && ((this.isSmall && this.containerToShow === "west") || (!this.isSmall && this.assetTree));
	}

	public eastExpanded() {
		return (this.showeast === undefined || this.showeast) && ((this.isSmall && this.containerToShow === "east") || (!this.isSmall && this.assetTray));
	}

	public visibleLayoutWest() {
		if (!this.isSmall && (this.showwest || this.showwest === undefined)) {
			return true;
		}
		return false;
	}
	public visibleLayoutEast() {
		if (!this.isSmall && (this.showeast || this.showeast === undefined)) {
			return true;
		}
		return false;
	}

	public visibleLayoutSouth() {
		return !this.isSmall && (this.showsouth || this.showsouth === undefined);
	}

	public changeSize(small: boolean) {
		//Transition large to small
		//Need to turn off the nav panels so the main panel takes the full screen. 
		if (small && !this.isSmall) {
			this.timeSlider = false;//Determines if the time slider is active. 
			this.assetTree = false;
			this.assetTray = false;
			this.containerToShow = "";
			this.movePanes("bottom");
		}
		else if (!small && this.isSmall) {
			//Transition from small to large
            //Need to turn on the nav panels
            this.timeSlider = angular.isDefined(this.showsouth) ? this.showsouth : true; //Determines if the time slider is active. 
            this.assetTree = angular.isDefined(this.showwest) ? this.showwest : true;
            this.assetTray = angular.isDefined(this.showeast) ? this.showeast : true;
            this.movePanes("top");
		}
		this.isSmall = small;
		this.aTXRedrawService.Layout("resize", ""); 
	}

	public movePanes(panesTo: string) {
		var westPane = $("#panewest");
		var southPane = $("#panesouth");
		var eastPane = $("#paneeast");
		var westPaneContainer = $("#paneWestContainer");
		var southPaneContainer = $("#paneSouthContainer");
		var eastPaneContainer = $("#paneEastContainer");
		var westContainer = $("#westContainer");
		var southContainer = $("#southContainer");
		var eastContainer = $("#eastContainer");

		if (panesTo === "bottom") {
			if (westPane.length > 0 && westContainer.length > 0) {
				westPane.detach();
				westContainer.append(westPane);
			}
			if (eastPane.length > 0 && eastContainer.length > 0) {
				eastPane.detach();
				eastContainer.append(eastPane);
			}
			if (southPane.length > 0 && southContainer.length > 0) {
				southPane.detach();
				southContainer.append(southPane);
			}
		}
		else {
			if (westPane.length > 0 && westPaneContainer.length > 0) {
				westPane.detach();
				westPaneContainer.append(westPane);
			}
			if (eastPane.length > 0 && eastPaneContainer.length > 0) {
				eastPane.detach();
				eastPaneContainer.append(eastPane);
			}
			if (southPane.length > 0 && southPaneContainer.length > 0) {
				southPane.detach();
				southPaneContainer.append(southPane);
			}
		}
	}

	//When any interaction occurs we want to save the time in the local storage area.  
	//This will cancel timers on other windows using the storage changed watcher.  
	private onUserInteraction() {
		this.$window.localStorage[this.checkForTimeoutKey] = (new Date()).getTime();
		this.cancelLogoutWarning(); 
	}

	//Logout warning is a key that indicates we are currently displaying a logout popup.  If it exists then we know we need to cancel the warning
	//if the user moves something.  
	private logoutWarning: string; 

	//THis method will popup a countdown toast if the timeout interval has been exceeded.  
	private checkForTimeout() {
		if (this.isUserInteractionTimedOut() && !this.logoutWarning) {
			this.logoutWarning = this.notifications.countdown(this.checkForTimeoutKey, "Due to inactivity user will be logged out.", 10, () => {
				//This is the callback that will actually log out the site if necessary.  
				//We want to do one last check to make sure the timeout interval is still exceeded before logging out.  
				if (this.isUserInteractionTimedOut()) {
					this.logout();
				}
				else {
					this.cancelLogoutWarning(); 
				}
			});
		}
	}

	//This is the function for when the last interaction time has changed.  It needs to check to make sure it is looking at the right
	//key.  After that it can cancel any pending timeout countdowns if necessary.  
	private storageChanged(event: StorageEvent) {
		if (event.key === this.checkForTimeoutKey && !this.isUserInteractionTimedOut()) {
			this.cancelLogoutWarning();
		}
	}

	//Called to kill any pending logout countdowns.  This can be called any time, even if there is no pending countdown.  
	private cancelLogoutWarning() {
		if (this.logoutWarning) {
			this.notifications.cancelCountdown(this.logoutWarning);
			this.logoutWarning = null;
		}
	}

	//This checks to see if the interval has been exceeded.  
	//It is kind of tricky because the storage value will be erased if the user is logged out.  
	//So we cache the last interaction time and use it only if the local storage version has been destroyed.  
	private cachedTimeoutValue: any; 
	private isUserInteractionTimedOut() {

		//If there is no timeout configured we need to make sure we don't ever say the user is timed out.  
		if (this.timeoutLength <= 0) {
			return false; 
		}

		let result = false; 

		let timeoutValueString = this.$window.localStorage[this.checkForTimeoutKey] || this.cachedTimeoutValue;
		if (!_.isNil(timeoutValueString)) {
			this.cachedTimeoutValue = timeoutValueString; 
			let timeoutValue: number = parseInt(timeoutValueString, 10);
			if (!isNaN(timeoutValue) && (((new Date()).getTime() - timeoutValue) > this.timeoutLength)) {
				result = true;
			}
		}

		return result; 
	}

	//Log out the user and redirect to the login page.  
	public logout() {
		this.accountModel.logout();
		this.atonixRedirector.RedirectToLogin();
	}

}

directivesModule.controller('bvPaneController', ['$timeout', '$interval', '$log', 'ATXRedrawService', '$window', 'assetsModel', 'baseModel', 'uiconfigModel','authorizationModel', 'notifications', 'accountModel', 'AtonixRedirector', ($timeout, $interval, $log, ATXRedrawService, $window, assetsModel, baseModel, uiconfigModel,authModel, notifications, accountModel, AtonixRedirector) => new PaneController($timeout, $interval, $log, ATXRedrawService, $window, assetsModel, baseModel, uiconfigModel,authModel, notifications, accountModel, AtonixRedirector)]);


// WEBPACK FOOTER //
// ./Common/Layout/LayoutController.ts